export function isEmptyOrWhiteSpace(str: string): boolean {
  return /\S/.test(str);
}
